import React from 'react'
import { Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const TotalUsers = ({usersData, dataLoading}) => {
  const navigate = useNavigate();

  return (
    <>
      {dataLoading ?  <div className='text-center mt-4'>
                          <Spinner animation="border" role="status" />
                      </div> : 
        <div className='flex flex-col'>
          <div className='flex justify-between items-center'>
            <span className='text-sm font-bold text-muted'>TOTAL USERS</span>
            <span>
              <img src='/images/users.png' alt='users' width={45} height={45} />
            </span>
          </div>
          <h3 className=''>{usersData.totalUsers}</h3>
          <div className='flex-center gap-2' style={{ lineHeight: '20px'}}>
            <div onClick={(e) => {e.stopPropagation(); navigate('/home/customers');}} className='flex-center flex-col rounded border border-black py-1 px-2'>
              <span style={{ color: '#0088FE', fontWeight: 800 }}>{usersData.customers}</span>
              <span>Customers</span>
            </div>
            <div onClick={(e) => {e.stopPropagation(); navigate('/home/providers');}} className='flex-center flex-col rounded border border-black py-1 px-2'>
              <span style={{ color: '#00C49F', fontWeight: 800 }}>{usersData.providers}</span>
              <span>Providers</span>
            </div>
          </div>
      </div>}
    </>
  )
}

export default TotalUsers